(ns frontend.view.entity-viewers.header-fields
  (:require
   [common.intelligence.common :as ic]
   [common.schema.data-types :as data-types]
   [common.schema.entities.pipeline :as pipeline]
   [common.schema.registry :as registry]
   [frontend.components.field-editor :as field-editor]
   [frontend.db :as app-db]
   [frontend.domain.oppo.calculated-fields :as oppo-calculated]
   [frontend.intelligence.icon :as intelligence-icon]
   [frontend.state.permissions :as state-permissions]
   [frontend.ui.component.percentage-layout.view :as percentage-layout]
   [frontend.ui.page.nnev.header.editor :as header-editor]
   [frontend.utils :as fu]
   [frontend.view.field-templates :as templates]
   [reagent.core :as r]
   [frontend.state.current-session :as session]))

(defn field-view
  [{:keys [entity field schema-lookup]}]
  (let [tenant @session/tenant
        tenant-schema @session/tenant-schema
        {:field/keys [data-type default-visibility] :as fs} (or (get schema-lookup field)
                                                                (registry/get-field-schema
                                                                 tenant-schema
                                                                 field))
        pipeline-id (pipeline/entity-pipeline entity)
        data-type (:field/data-type fs)
        editor-type (or (:editor/type fs)
                        (:editor default-visibility))
        ;; header-board fields are read-only - override :editor.type/none:
        ;; -TODO proper place? schema? individual-nevs?
        editor-type (if (= editor-type :editor.type/none)
                      (->> data-types/zapflow-data-types
                           data-type
                           :default-editor)
                      editor-type)
        entity-type (:entity/type entity)
        access (state-permissions/get-access {:entity      entity
                                              :pipeline-id pipeline-id
                                              :field       field})
        no-access? (not access)
        not-valid? (not (templates/valid-attribute? field entity))

        attribute (:attribute fs)
        base-entity (fu/base-entity entity field)
        base-entity-type (:entity/type base-entity)
        enriched-entity (when base-entity-type
                          (ic/enrich-entity base-entity))
        intelligence-value (get enriched-entity attribute)
        value (fu/get-value tenant tenant-schema base-entity attribute)
        is-intelligence-value? (and (nil? value)
                                    (contains? enriched-entity attribute))
        class-name (fu/cs "header-board-viewer"
                          (when no-access?
                            "disabled"))]
    [field-editor/view
     (merge fs
            {:value             (if is-intelligence-value? intelligence-value value)
             :containing-entity base-entity
             :entity-type       base-entity-type
             :read-only?        true
             :toggle-viewer?    true
             :drag-options      {:hide-drag-area? true}
             :entity-id         (:db/id entity)
             :editor/type       editor-type
             :class-name        class-name}
            (when is-intelligence-value?
              {:source-options {:source-icon-fn intelligence-icon/view}})
            (when-let [secondary-attribute (:field/secondary-attribute fs)]
              {:secondary-view-args
               (let [sec-fs (registry/get-field-schema tenant-schema secondary-attribute)
                     current-value (get entity secondary-attribute)]
                 (merge
                  sec-fs
                  {:value       current-value
                   :editor/type :editor.type/select
                   :read-only?  true}))})
            (when (or no-access?
                      not-valid?)
              {:editor/type :editor.type/text-simple
               :value       "-"}))]))

(defn field-row-view
  [{:keys [field-row entity schema-lookup]}]
  (let [{:keys [fields field-layout]} field-row
        percentages (get header-editor/layout-widths field-layout)
        field-count (count percentages)
        indexes (range field-count)]
    [:div
     (into
      [percentage-layout/view
       {}
       percentages]
      (for [[i {:keys [field]}] (->> indexes
                                     (map (fn [i]
                                            [i (get fields i)])))]
        ^{:key (str "field-" field "-" i)}
        (if (some? field)
          [field-view
           {:field         field
            :entity        entity
            :schema-lookup schema-lookup}]
          [:div ""])))]))

(defn view
  [{:keys [entity field-defs schema]}]
  (let [schema-lookup @(r/track into {} schema)
        entity (if (= (:entity/type entity) :entity.type/oppo)
                 (oppo-calculated/add-calculated-fields (:server-time @app-db/session)
                                                        entity)
                 entity)]
    [:div
     (for [[i {:keys [fields] :as field-row}] (map vector (range) field-defs)]
       ^{:key (str "f-row-" i
                   "-" (->> fields
                            (map :field)))}
       [field-row-view
        {:entity        entity
         :field-row     field-row
         :schema-lookup schema-lookup}])]))
